module.exports = __webpack_public_path__ + "img/kommune-1837.91f06657.svg";